import React, { useEffect } from 'react';

const Vasileiadis = () => {
  useEffect(() => {
    if (!localStorage.qr) {
      localStorage.qr = 'Vasileiadis';
    }
    window.location.replace('/');
  }, [])
  return <p></p>
}

export default Vasileiadis;
